<template>
    <div>
        <Header @show-contact="showContact" :active="2" :title="'解决方案'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/banner/banner_training.jpg"></img>
            <img class="banner_m" src="../../assets/image/banner/banner_training_m.png"></img>
        </div>
        <!-- 单兵军体训练【狙击、跳伞】 -->
        <p class="titles">单兵军体训练【狙击、跳伞】</p>
        <div class="system-a" style="background-color: #d9eae9;">
            <div class="contents">
                <img src="../../assets/image/solution/training_system.jpg" alt="Image">
                <div class="right">
                    <h1>亮点</h1>
                    <p>
                        多场景 反复沉浸训练<br>
                        安全、提高效率，降低成本和损耗<br>
                        记录数据、视频和及时训练评估<br>
                        可在虚拟环境中高、智、慧训练系列仿真多型号轻武器外弹道射击参数和特性
                    </p>
                </div>
            </div>
            <div class="contents-m">
                <p>亮点:多场景 反复沉浸训练；安全、提高效率，降低成本和损耗；记录数据、视频和及时训练评估；可在虚拟环境中高、智、慧训练系列仿真多型号轻武器外弹道射击参数和特性。</p>
                <img src="../../assets/image/solution/training_system_m.jpg" alt="Image">
            </div>
            <div class="mix-a">
                <img src="../../assets/image/solution/training_mix1.jpg">
                <img src="../../assets/image/solution/training_mix2.jpg">
                <img src="../../assets/image/solution/training_mix3.jpg">
                <img src="../../assets/image/solution/training_mix4.jpg">
            </div>
        </div>
        <!-- 智能ZZ -->
        <p class="titles">智能ZZ</p>
        <div class="system-a" style="background-color: #f3e9d9;">
            <div class="contents">
                <img src="../../assets/image/solution/training_system2.jpg" alt="Image">
                <div class="right">
                    <h1>亮点</h1>
                    <p>
                        增强视野<br>
                        态势视图<br>
                        无人ZZZB操控<br>
                        眼动、语音、手势、多样交互方式<br>
                        灵活性与便捷性<br><br>
                    </p>
                </div>
            </div>
            <div class="contents-m">
                <p>亮点:增强视野；态势视图；无人ZZZB操控；眼动、语音、手势、多样交互方式；灵活性与便捷性。</p>
                <img src="../../assets/image/solution/training_system_m.jpg" alt="Image">
            </div>
            <div class="mix-a">
                <img src="../../assets/image/solution/training_mix5.jpg">
                <img src="../../assets/image/solution/training_mix6.jpg">
                <img src="../../assets/image/solution/training_mix7.jpg">
                <img src="../../assets/image/solution/training_mix8.jpg">
            </div>
        </div>
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false,
            productsList: ['VR军事仿真训练系统', '多人实战训练系统','综合军体训练测评系统'],
            current: 0,
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script> 
<style scoped>
@import '../../assets/css/solution/aviation.css';
</style>